import { Component, OnInit } from '@angular/core';
import { CuentasModel, ResponseCuentasModel } from 'src/app/model/Cuentas.model';
import { apiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css']
})
export class ReportesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
